module.exports = __webpack_public_path__ + "static/media/lineIcon.cd8408b4.png";